<template>
  <section class="root">
    <div class="grid-flow">
      <article v-for="e in blok.employees" :key="e.id">
        <img loading="lazy" :src="transformImage(e.image, '150x150')" :alt="e.name" width="110" height="110">
        <p class="name" data-inspect="p">
          <span>{{ e.name }}</span>
          <a title="LinkedIn Profile" :href="e.linkedin_url" target="_blank" v-if="e.linkedin_url"
            :aria-label="`${e.name} - LinkedIn Profile`">
            <cms-social-icons icon="linkedin"></cms-social-icons>
          </a>
        </p>
        <p class="role zero-mp">{{ e.title }}</p>
      </article>
    </div>
  </section>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-team-list",
}
</script>

<style scoped>
.grid-flow {
  --flow-width: 150px;
}

@media screen and (min-width: 786px) {
  .grid-flow {
    --flow-width: 180px;
  }
}

article {
  color: var(--crf-text);
  display: grid;
  padding: 0.85rem;
  border-radius: 8px;
  background-color: var(--crf-bg-high);
  box-shadow: var(--crf-shadow);
  grid-template-rows: min-content min-content 1fr;
}

img {
  border-radius: 50%;
  margin: 0 auto;
  aspect-ratio: 1/1;
}

p.name {
  margin: 12px 0 5px 0;
  padding: 10px 0 0 0;
  font-size: 0.9rem;
  border-top: 1px solid var(--crf-border);
  color: var(--crf-flip);
  font-weight: 700;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: baseline;
}

p.role {
  font-size: 0.8rem;
}
</style>
